'use strict';

var encoder = require('./encoder');

function fixed64EncodingLength() {
  return 8;
}

function fixed64Encode(val, buffer, dataView, offset) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = val[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var byte = _step.value;
      buffer[offset] = byte;
      offset++;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  fixed64Encode.bytes = 8;
}

function fixed64Decode(buffer, dataView, offset) {
  var val = buffer.slice(offset, offset + 8);
  fixed64Decode.bytes = 8;
  return val;
}

module.exports = encoder(1, fixed64Encode, fixed64Decode, fixed64EncodingLength);